var calPickerClickHandler = null;
var calPickerKeydownHandler = null;
var calPickerTriggerClickHandler = null;

document.addEventListener("turbo:load", initMobileWebAiCalendarPicker);

function initMobileWebAiCalendarPicker() {
  if (!document.body.classList.contains("mobile-web-ai")) return;

  var trigger = document.getElementById("mwai-calendar-picker-trigger");
  var dropdown = document.getElementById("mwai-calendar-picker-dropdown");

  if (!trigger || !dropdown) return;

  if (calPickerTriggerClickHandler) {
    trigger.removeEventListener("click", calPickerTriggerClickHandler);
  }
  calPickerTriggerClickHandler = function (e) {
    e.preventDefault();
    e.stopPropagation();

    var avatarDropdown = document.getElementById("mwai-avatar-dropdown");
    if (avatarDropdown) avatarDropdown.classList.remove("active");

    dropdown.classList.toggle("active");
  };
  trigger.addEventListener("click", calPickerTriggerClickHandler);

  if (calPickerClickHandler) {
    document.removeEventListener("click", calPickerClickHandler);
  }
  calPickerClickHandler = function (e) {
    if (!trigger.contains(e.target) && !dropdown.contains(e.target)) {
      dropdown.classList.remove("active");
    }
  };
  document.addEventListener("click", calPickerClickHandler);

  if (calPickerKeydownHandler) {
    document.removeEventListener("keydown", calPickerKeydownHandler);
  }
  calPickerKeydownHandler = function (e) {
    if (e.key === "Escape" && dropdown.classList.contains("active")) {
      dropdown.classList.remove("active");
    }
  };
  document.addEventListener("keydown", calPickerKeydownHandler);
}

document.addEventListener("turbo:before-cache", function () {
  var dropdown = document.getElementById("mwai-calendar-picker-dropdown");
  if (dropdown) dropdown.classList.remove("active");
});
